export default function readCookie(key) {
  const r = RegExp(`(^|; )${encodeURIComponent(key)}=([^;]*)`).exec(document.cookie);
  return r ? r[2] : null;
}
